import React, { useState, useEffect } from 'react';
import { CardBody, Col, Row } from "reactstrap";
import '../global/GlobalCSS.css';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '..';
import { VesselState, getConfigurationLimitsAction, getVoyagesAction, setVesselID, setVesselState, setVoyageID } from "../Store/Generic/ReportingSlice";
import CreateVoyage from './CreateVoyage';
import ToolTip from '../Components/ToolTip';
import VesselReportingIcon from '../Media/vesselReporting.png';
import DeletePopOver from '../Components/DeletePopOver';
import { Get } from 'VesselMaster/vesselMaster.hooks';
import { useQuery } from 'react-query';
import { queryKeyes } from 'shared/queryKeys';
import { successToast } from 'Components/Toasts';
import apiGlobal from 'global/api.global';
import { hasRole } from 'utils/auth/authUtils';
import { offlineEditStatus, Roles, VoyageConstant } from 'shared/constants';
import PopOver from 'Components/PopOver';
import { queryClient } from 'react-query/queryClient';
import VoyageTableHeadComponent from './VoyageTableHeadComponent';
import EditIcon from '../Media/ED2.png';
import DisableEditIcon from '../Media/ED2_disabled.png';
import DeleteIcon from '../Media/delete.png';
import DisabledDeleteIcon from '../Media/delete_disabled.png';
import CompleteVoyageIcon from '../Media/doubleTick.png'
import DisabledCompleteVoyageIcon from '../Media/doubleTick_disabled.png'
import ErrorComponent from 'Components/ErrorComponent';
import DisabledVesselReportingIcon from '../Media/vesselReporting_disabled.png';
import env from 'environment_system/env_system';
import Message from 'Components/Message';
import { dateTimeFormat, formattooltip } from 'GenericForms/Helper';
import TableLoading from 'Components/TableLoading';

const OngoingVoyage = () => {
    const dispatch = useDispatch();
    const { Vessels, VesselID, VesselState, VoyageID } = useSelector((state: RootState) => state.Reporting);
    const vessel = Vessels.find((rec: { [key: string]: string | number | boolean | Date }) => rec.id === VesselID);
    const [deletePopOverState, setDeletePopOverState] = useState<boolean>(false);
    const [completeVoyBoolean, setCompleteVoyBoolean] = useState(false);
    const [target, setTarget] = useState<string>("");
    const [voyObj, setVoyObj] = useState<any>({});
    const [hoverId, setHoverId] = useState<string | null>(null);
    const [createDisabled, setCreateDisabled] = useState<boolean>(false);
    const [deleteName, setDeleteName] = useState<string>('');
    const handleVesselState = (rowID: number, voyageID: number, record: VesselState) => {
        dispatch(setVesselID(rowID))
        dispatch(setVoyageID(voyageID))
        dispatch(setVesselState(record))
    }
    useEffect(() => {
        queryClient.invalidateQueries(
            queryKeyes.vessel.VoyageList.key
        );
    }, [])

    useEffect(() => {
        dispatch(getVoyagesAction('voyage_information' as string));
    }, [dispatch]);

    const { data: voyages, isLoading: voyagesFetching, isError: voyagesError } = useQuery(
        [queryKeyes.vessel.VoyageList.key, VesselID],
        async () => await Get(queryKeyes.vessel.VoyageList.url(VesselID), VesselID),
        {
            staleTime: Infinity
        })
    const isDisabled: boolean =
        vessel?.offline_edit_status === offlineEditStatus.OFFLINE_EDIT_REPORT_ACTIVATED
            ? true
            : (!env?.offlineCopy && vessel?.is_vessel_offline)
                ? true
                : voyages?.some((v: any) => v.voyage_status === VoyageConstant.NEWVOYAGE);


    const handleCloseVoyage = async (voyage: any) => {
        try {
            voyage.voyage_status = VoyageConstant.COMPLETED;
            const response = await apiGlobal.put(`/voyage_information/${voyage.id}/`, voyage).then(async res => {
                if (res.status === 200) {
                    setCompleteVoyBoolean(false);
                    await queryClient.invalidateQueries(queryKeyes.pagination.VoyageListPage.key);
                    await queryClient.invalidateQueries(queryKeyes.vessel.VoyageList.key);
                    dispatch(getVoyagesAction('voyage_information' as string));
                    successToast("Voyage completed successfully!");
                }
            });
            return response;
        } catch (err) {
            console.error(err);
            return null;
        }
    }

    const handleDeleteVoyage = async (voyage: any) => {
        try {
            voyage.voyage_status = VoyageConstant.CLOSED;
            const response = await apiGlobal.delete(`/voyage_information/${voyage.id}/`, voyage).then(res => {
                if (res.status === 200 || res.status === 204) {
                    setDeletePopOverState(false);
                    queryClient.invalidateQueries(queryKeyes.vessel.VoyageList.key);
                    queryClient.invalidateQueries(queryKeyes.pagination.VoyageListPage.key);
                    successToast("Voyage deleted successfully!");
                }
            });
            return response;
        } catch (err) {
            console.error(err);
            return null;
        }
    }

    return (
        <React.Fragment>
            <React.Fragment>
                <CardBody className='p-0'>
                    <Row className='d-flex'>
                        <Col className='' sm={6}>
                            <h4 id='owner_table'>Voyage Reporting Information</h4>
                        </Col>
                        <Col sm={{ size: 2, offset: 4 }} className='text-right'>
                            {(hasRole(Roles.ES_ADMIN) || hasRole(Roles.MASTER) || hasRole(Roles.ADMIN)) &&
                                <span id={'disabled'}
                                    onMouseEnter={() => isDisabled && setCreateDisabled(true)}
                                    onMouseLeave={() => setCreateDisabled(null)}
                                >
                                    <button
                                        color='primary'
                                        className='btn btn-primary mb-3'
                                        disabled={isDisabled}
                                        onClick={async () => {
                                            !isDisabled && handleVesselState(VesselID, -1, 'CREATE_VOYAGE_REPORTING');
                                        }}>
                                        <i className="dripicons-plus font-size-16 align-middle me-2" />
                                        Create New
                                    </button>
                                </span>
                            }
                            {(hasRole(Roles.ES_ADMIN) || hasRole(Roles.MASTER) || hasRole(Roles.ADMIN)) && createDisabled &&
                                <ToolTip
                                    isOpen={createDisabled}
                                    target={'disabled'}
                                    message="Only one Voyage with status new can exist at a time. Please complete or delete the existing record before creating a new one."
                                />
                            }
                        </Col>
                    </Row>
                    <div className="table-responsive" id='owner_table'>
                        {(voyagesFetching) && (
                            <TableLoading Rows={3} />
                        )}
                        {voyagesError && (
                            <ErrorComponent message='Unable to load voyage list!' />
                        )}
                        {((!voyagesFetching && !voyagesError) && voyages.length > 0) &&
                            <table className="table mb-0">
                                <VoyageTableHeadComponent tab={1} />
                                <tbody>
                                    {(() => {
                                        const filteredVoyages = voyages.filter(
                                            (item: any) =>
                                                item.display === true &&
                                                item.voyage_status !== VoyageConstant.CLOSED
                                        );
                                        if (filteredVoyages.length === 0) {
                                            return (
                                                <tr>
                                                    <td colSpan={8} className="text-center p-3 text-muted">
                                                        <Message message="No voyages available" type="danger" />
                                                    </td>
                                                </tr>
                                            );
                                        }
                                        return filteredVoyages.map((Voyage: any, index: number) => (
                                            <React.Fragment key={Voyage.id}>
                                                <tr>
                                                    <td className="p-2 align-middle text-center">{index + 1}</td>
                                                    <td className="p-2 align-middle">{Voyage.voyage_number}</td>
                                                    <td className="p-2 align-middle text-left">
                                                        {Voyage.voyage_status === VoyageConstant.NEWVOYAGE ? (
                                                            <p className='mb-0'>New</p>
                                                        ) : Voyage.voyage_status === VoyageConstant.ONGOING ? (
                                                            <p className='mb-0'>Ongoing</p>
                                                        ) : Voyage.voyage_status === VoyageConstant.COMPLETED ? (
                                                            <p className='mb-0'>Completed</p>
                                                        ) : (
                                                            <p className='mb-0'>Closed</p>
                                                        )}
                                                    </td>
                                                    <td className="p-2 align-middle text-left">{dateTimeFormat(Voyage?.departure_date_time, false, false, true) ?? 'TBD'}</td>
                                                    {env.inDevelopment && <td className="p-2 align-middle text-center">
                                                        {(hasRole(Roles.ES_ADMIN) || hasRole(Roles.ADMIN)) && (
                                                            <i
                                                                className="bx bx-calendar-edit pointer icon_s32 color-assign-user align-middle"
                                                                id={`Off_hire_${vessel.id}`}
                                                                onMouseEnter={() => setHoverId(`Off_hire_${vessel.id}`)}
                                                                onMouseLeave={() => setHoverId(null)}
                                                                onClick={() => {
                                                                    dispatch(getConfigurationLimitsAction(vessel.id as number));
                                                                    handleVesselState(
                                                                        vessel.id as number,
                                                                        Voyage.id,
                                                                        'OFF_HIRE'
                                                                    );
                                                                }}
                                                            />
                                                        )}
                                                    </td>}
                                                    <td className="p-2 align-middle text-center">
                                                        {(
                                                            hasRole(Roles.ES_ADMIN) ||
                                                            hasRole(Roles.MANAGER) ||
                                                            hasRole(Roles.MASTER) ||
                                                            hasRole(Roles.ADMIN)
                                                        ) &&
                                                            <React.Fragment>
                                                                <img
                                                                    src={Voyage?.voyage_status === VoyageConstant.NEWVOYAGE ? EditIcon : DisableEditIcon}
                                                                    alt="Edit Icon"
                                                                    height="28"
                                                                    className='pointer'
                                                                    id={`${Voyage?.voyage_status === VoyageConstant.NEWVOYAGE ? `Edit_voyage_${Voyage.id}` : `Edit_voyage_disabled_${Voyage.id}`}`}
                                                                    onMouseEnter={() => setHoverId(`${Voyage?.voyage_status === VoyageConstant.NEWVOYAGE ? `Edit_voyage_${Voyage.id}` : `Edit_voyage_disabled_${Voyage.id}`}`)}
                                                                    onMouseLeave={() => setHoverId(null)}
                                                                    onClick={() => {
                                                                        if (Voyage?.voyage_status === VoyageConstant.NEWVOYAGE) {
                                                                            handleVesselState(VesselID, Voyage.id, 'VOYAGE_REPORTING_EDIT');
                                                                        }
                                                                    }}
                                                                />
                                                            </React.Fragment>
                                                        }
                                                    </td>
                                                    <td className="p-2 align-middle text-center">
                                                        {(
                                                            hasRole(Roles.ES_ADMIN) ||
                                                            hasRole(Roles.MASTER) ||
                                                            hasRole(Roles.CHIEFENGINEER) ||
                                                            hasRole(Roles.MANAGER) ||
                                                            hasRole(Roles.ADMIN)
                                                        ) &&
                                                            <React.Fragment>
                                                                <img alt=""
                                                                    src={(Voyage?.voyage_status === VoyageConstant.NEWVOYAGE && voyages.filter((item: any) =>
                                                                        item.display === true && item?.voyage_status === VoyageConstant.ONGOING)?.length > 0) ?
                                                                        DisabledVesselReportingIcon : VesselReportingIcon}
                                                                    height="32"
                                                                    id={(Voyage?.voyage_status === VoyageConstant.NEWVOYAGE && voyages.filter((item: any) =>
                                                                        item.display === true && item?.voyage_status === VoyageConstant.ONGOING)?.length > 0) ?
                                                                        `Vessel_Reporting_disabled_${Voyage.id}` : `Vessel_Reporting_${Voyage.id}`}
                                                                    onMouseEnter={() => setHoverId((Voyage?.voyage_status === VoyageConstant.NEWVOYAGE && voyages.filter((item: any) =>
                                                                        item.display === true && item?.voyage_status === VoyageConstant.ONGOING)?.length > 0) ?
                                                                        `Vessel_Reporting_disabled_${Voyage.id}` : `Vessel_Reporting_${Voyage.id}`)}
                                                                    onMouseLeave={() => setHoverId(null)}
                                                                    className={`${(Voyage?.voyage_status === VoyageConstant.ONGOING ||
                                                                        (Voyage?.voyage_status === VoyageConstant.NEWVOYAGE && voyages.filter((item: any) =>
                                                                            item.display === true && item?.voyage_status === VoyageConstant.ONGOING)?.length === 0)) ?
                                                                        'pointer' : ''}`
                                                                    }
                                                                    onClick={() => {
                                                                        if (Voyage?.voyage_status === VoyageConstant.ONGOING || Voyage?.voyage_status === VoyageConstant.COMPLETED ||
                                                                            (Voyage?.voyage_status === VoyageConstant.NEWVOYAGE && voyages.filter((item: any) =>
                                                                                item.display === true && item?.voyage_status === VoyageConstant.ONGOING)?.length === 0)
                                                                        ) {
                                                                            handleVesselState(VesselID, Voyage.id, 'ONGOING_VESSEL_REPORTING');
                                                                            setHoverId(null);
                                                                        }
                                                                    }}
                                                                />
                                                            </React.Fragment>
                                                        }
                                                    </td>
                                                    <td className="p-2 align-middle text-center">
                                                        {(
                                                            hasRole(Roles.ES_ADMIN) ||
                                                            hasRole(Roles.MASTER) ||
                                                            hasRole(Roles.MASTER) ||
                                                            hasRole(Roles.ADMIN)
                                                        ) &&
                                                            <React.Fragment>
                                                                <img
                                                                    alt=""
                                                                    src={Voyage?.voyage_status === VoyageConstant.NEWVOYAGE ||
                                                                        Voyage?.voyage_status === VoyageConstant.COMPLETED ? DisabledCompleteVoyageIcon :
                                                                        CompleteVoyageIcon
                                                                    }
                                                                    height="28"
                                                                    className='pointer'
                                                                    id={Voyage?.voyage_status === VoyageConstant.COMPLETED ? `Completed_Voyage_${index}` : `Complete_Voyage${index}`}
                                                                    onMouseEnter={() => setHoverId(Voyage?.voyage_status === VoyageConstant.COMPLETED ? `Completed_Voyage_${index}` : `Complete_Voyage${index}`)}
                                                                    onMouseLeave={() => setHoverId(null)}
                                                                    onClick={async () => {
                                                                        if (
                                                                            Voyage?.voyage_status === VoyageConstant.NEWVOYAGE ||
                                                                            Voyage?.voyage_status === VoyageConstant.COMPLETED
                                                                        ) {
                                                                            setHoverId(null);
                                                                            return;
                                                                        }
                                                                        setTarget(`Complete_Voyage${index}`);
                                                                        setVoyObj(Voyage);
                                                                        setCompleteVoyBoolean(true);
                                                                    }}
                                                                />
                                                            </React.Fragment>
                                                        }
                                                    </td>
                                                    <td className="p-2 align-middle text-center">
                                                        {(hasRole(Roles.ES_ADMIN) ||
                                                            hasRole(Roles.MANAGER) ||
                                                            hasRole(Roles.MASTER) ||
                                                            hasRole(Roles.ADMIN)
                                                        ) &&
                                                            <React.Fragment>
                                                                <img
                                                                    alt=""
                                                                    src={Voyage?.voyage_status === VoyageConstant.NEWVOYAGE ?
                                                                        DeleteIcon : DisabledDeleteIcon}
                                                                    height="28"
                                                                    className='pointer'
                                                                    id={Voyage?.voyage_status === VoyageConstant.NEWVOYAGE ?
                                                                        `Delete_Voyage_${index}` : `Delete_Voyage_Disabled_${index}`}
                                                                    onMouseEnter={() => setHoverId(Voyage?.voyage_status === VoyageConstant.NEWVOYAGE ?
                                                                        `Delete_Voyage_${index}` : `Delete_Voyage_Disabled_${index}`)}
                                                                    onMouseLeave={() => setHoverId(null)}
                                                                    onClick={async () => {
                                                                        if (Voyage?.voyage_status === VoyageConstant.NEWVOYAGE) {
                                                                            setTarget(`Delete_Voyage_${index}`);
                                                                            setDeletePopOverState(true);
                                                                            setVoyObj(Voyage);
                                                                            setDeleteName(Voyage.voyage_number)
                                                                            setHoverId(null);
                                                                        }
                                                                        setHoverId(null);
                                                                    }}
                                                                />
                                                            </React.Fragment>
                                                        }
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        ));
                                    })()}
                                </tbody>
                            </table>
                        }
                        {completeVoyBoolean &&
                            <PopOver
                                target={target}
                                handleClick={() => {
                                    handleCloseVoyage(voyObj)
                                    setHoverId(null);
                                }}
                                message={'Are you sure you want to complete the voyage?'}
                                state={completeVoyBoolean}
                                setState={setCompleteVoyBoolean}
                            />
                        }
                        {deletePopOverState &&
                            <DeletePopOver
                                target={target}
                                onClick={() => {
                                    handleDeleteVoyage(voyObj)
                                    setHoverId(null);
                                }}
                                state={deletePopOverState}
                                setState={setDeletePopOverState}
                                message={`Are you sure you want to delete ${deleteName}`}
                            />
                        }
                        {hoverId !== null &&
                            <ToolTip
                                target={hoverId}
                                message={formattooltip(hoverId)}
                                isOpen={hoverId !== null}
                            />
                        }
                    </div>
                </CardBody>
            </React.Fragment >
            {VesselState === 'CREATE_VOYAGE_REPORTING' && <CreateVoyage />}
            {VesselState === 'VOYAGE_REPORTING_EDIT' && <CreateVoyage voyageId={VoyageID} />}
        </React.Fragment>
    )
}
export default OngoingVoyage;